import { Chip, Tooltip } from "@mui/material";
import React from "react";
import { Base } from "ui/Scripts/source/framework/base";

interface IAppReportListStateChipProps {
    icon?: React.ReactElement;
    code: string;
    color: string;
    fullWidth?: boolean;
}

export const AppReportListStateChip = (props: IAppReportListStateChipProps) => {
    const textColor = Base.invertColor(props.color, true);

    return (
        <Tooltip title={props.code}>
            <Chip
                icon={props.icon}
                label={props.code}
                size="small"
                sx={{ backgroundColor: props.color, color: textColor, width: props.fullWidth ? "100%" : null }}
            />
        </Tooltip>
    );
};
